import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Attach the admin token as a Bearer header so auth works even when the browser
// blocks cross-site cookies (e.g. Safari in the preview iframe).
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("bc_admin_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const STAG_LOGO = "https://static.prod-images.emergentagent.com/jobs/9bff4ab9-dd73-4d4d-b08f-2ac82670e25c/images/fc98e0572339d96cfbccedef02f5f7d726de32938e0ef867577524bf61d3407a.jpeg";

export default api;
